import Vue from 'vue'
import Router from 'vue-router'

import { getAccessToken } from '@/api/http'
import store from '@/store'

const Login = () => import('@/views/Login.vue')
const AppLayout = () => import('@/views/layout/AppLayout.vue')
const Visitors = () => import('@/views/app/Visitors.vue')
const Assessments = () => import('@/views/app/Assessments.vue')
const AssessmentDetail = () => import('@/views/app/AssessmentDetail.vue')
const ScalesManage = () => import('@/views/app/ScalesManage.vue')
const SystemSettings = () => import('@/views/app/SystemSettings.vue')
const VisitorAssignment = () => import('@/views/app/VisitorAssignment.vue')
const UserProfile = () => import('@/views/app/UserProfile.vue')
const PublicAssessment = () => import('@/views/public/PublicAssessment.vue')
const PublicResult = () => import('@/views/public/PublicResult.vue')
const NotFound = () => import('@/views/NotFound.vue')

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      redirect: () => {
        return getAccessToken() ? '/app/visitors' : '/login'
      }
    },
    { path: '/login', component: Login },
    {
      path: '/app',
      component: AppLayout,
      meta: { requiresAuth: true },
      children: [
        { path: 'visitors', component: Visitors },
        { path: 'assessments', component: Assessments },
        { path: 'assessments/:id', component: AssessmentDetail, props: true },
        { path: 'scales', component: ScalesManage },
        { path: 'settings', component: SystemSettings },
        { path: 'relations', component: VisitorAssignment },
        { path: 'profile', component: UserProfile },
      ],
    },
    { path: '/public/:uid', component: PublicAssessment, props: true },
    { path: '/public/:uid/result', component: PublicResult, props: true },
    { path: '*', component: NotFound },
  ],
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (!requiresAuth) return next()

  const token = getAccessToken()
  if (!token) return next({ path: '/login', query: { next: to.fullPath } })

  const ensureMe = async () => {
    if (!store.state.me) {
      try {
        await store.dispatch('fetchMe')
      } catch (e) {
        store.commit('setMe', null)
      }
    }
  }

  ensureMe().then(() => {
    const me = store.state.me || {}
    const isSuperuser = !!me.is_superuser
    const isAdmin = me.role === 'admin'

    // System Settings: Only Superuser
    if (to.path.startsWith('/app/settings')) {
      if (!isSuperuser) return next('/app/visitors')
    }

    // Scales & Relations: Superuser OR Admin
    if (to.path.startsWith('/app/scales') || to.path.startsWith('/app/relations')) {
      if (!isSuperuser && !isAdmin) return next('/app/visitors')
    }

    return next()
  })
})

export default router
